import { render, staticRenderFns } from "./BankAuthLett.vue?vue&type=template&id=2b310286&scoped=true&"
import script from "./BankAuthLett.vue?vue&type=script&lang=js&"
export * from "./BankAuthLett.vue?vue&type=script&lang=js&"
import style0 from "./BankAuthLett.vue?vue&type=style&index=0&id=2b310286&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b310286",
  null
  
)

export default component.exports